module.exports = __webpack_public_path__ + "img/GA.bfe9320a.svg";